import React, { useEffect, useRef, useState } from "react";
import styles from "./login.module.scss";

import { ButtonGroup } from "../../components/ui/buttons/Button";

import { JSEncrypt } from "jsencrypt";
import OtpInput from "react-otp-input";

import useAuth, {
  generateRandomUUID,
  getAesEncryptedData,
  getRsaEncryptedData,
} from "../../hooks/useAuth";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ROUTES } from "../../routes";
import AuthService from "../../api/auth-service";
import { AUTH_API_URL } from "../../api/urlMetaData";
import { REDIRECT } from "../../utils/redirectUrl";

const inputStyle = {
  width: "50px",
  height: "50px",
  border: "1px solid #090D28",
  fontSize: "1.5rem",
};

function VerifyOTPForm() {
  const navigate = useNavigate();
  const { userName } = useSelector((state) => state.auth.form);

  const form = useSelector((state) => state.auth.form);
  const verifyBtn = useRef(null);

  const [loading, setLoading] = useState(false);

  const auth = useAuth();

  const [otp, setOtp] = useState("");
  const [allow, setAllow] = useState(false);

  const inputNums = 6;

  const handleInput = (otp) => setOtp(otp);

  // checking if userName exists on the login page form
  useEffect(() => {
    if (!form.userName) navigate(ROUTES.LOGIN);
  }, []);

  useEffect(() => {
    setOtp(otp);
    setAllow(false);
    if (otp.length === inputNums) {
      setAllow(true);
      verifyBtn.current.focus();
    }
  }, [otp]);

  const verifyOneTimePassword = async () => {
    setLoading(true);
    // generate the random salt for payload encryptions
    const randomUUID = generateRandomUUID();
    const EncryptedOtp = getAesEncryptedData(otp, randomUUID);

    const aesKeyEncryptedUsingPublicKey = getRsaEncryptedData(
      randomUUID,
      JSEncrypt
    );

    const verified = await auth.verifyOTP({
      userName,
      otp: EncryptedOtp,
      aesKeyEncryptedUsingPublicKey,
    });

    if (!verified.success) {
      setLoading(false);
      return navigate(ROUTES.LOGIN, {
        replace: true,
      });
    }

    if (verified.choosePassword) {
      return navigate(ROUTES.DEFAULT_PASSWORD, {
        replace: true,
      });
    }

    // choose regions
    if (verified.multipleRegions) {
      return navigate(ROUTES.REGION, {
        replace: true,
      });
    }

    const client = await auth.fetchClientDetails();

    if (client) {
      setLoading(false);

      // Redirect to stackintel EM
      // const isMobile = /mobile|android|iphone|ipad/i.test(navigator.userAgent);

      // if (isMobile) {
      //   const redirectURL = isMobile ? REDIRECT.pwa : REDIRECT.web;

      //   AuthService.get(AUTH_API_URL.TOKEN_FOR_PARTNER).then((res) => {
      //     const token = res.headers["x-stackintel-authorization"];

      //     if (!token || token === undefined) {
      //       toast.error("Redirection to Expense Management failed.");
      //       return;
      //     }

      //     window.open(
      //       `${redirectURL}/?xt=${token}`,
      //       "_self",
      //       "noopener,noreferrer"
      //     );
      //   });

      //   return;
      // }

      // go to dashboard
      return navigate(ROUTES.DASHBOARD, {
        replace: true,
      });
    }
  };

  return (
    <>
      <main>
        <div className={`${styles.otp_wrapper}`}>
          <div className="mb-3">
            <h3 className="text-secondary">
              Please verify your email address.
            </h3>
            <p>A new OTP has been sent to your email.</p>
          </div>
          <OtpInput
            value={otp}
            containerStyle={styles.otp_container}
            inputStyle={inputStyle}
            onChange={handleInput}
            numInputs={6}
            isInputNum
            renderSeparator={<span className="mx-2"></span>}
            renderInput={(props) => <input {...props} />}
            inputType="tel"
            shouldAutoFocus
          />
          <ButtonGroup>
            <button
              disabled={loading}
              ref={verifyBtn}
              className={`btn btn-primary btn-lg mt-4 ${
                !allow ? "disabled" : ""
              }`}
              onClick={() => verifyOneTimePassword()}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : null}
              <span>Verify OTP</span>
            </button>
          </ButtonGroup>
          <button className="btn btn-link mt-5" onClick={() => navigate(-1)}>
            {"Go Back"}
          </button>
        </div>
      </main>
    </>
  );
}

export default VerifyOTPForm;
